import { mountVue, mountVueWithPinia } from '../vue/mountVue';
import { determineRecommendation } from '@utils/ProductResources';
import ProductGrid from '../vue/ProductCards/ProductGrid.vue';
import ProductSlider from '../vue/ProductCards/ProductSlider.vue';

const passJsonAsProp = async (el, content) => {
  const data = JSON.parse(content) ?? false;
  if (!data) return;

  const recommendation = data?.recommendation ?? false;
  if (!recommendation) return el.setAttribute('props-data', content);

  const limit = data?.limit_recommendations ?? false;
  data.items = await determineRecommendation(recommendation, limit);

  return el.setAttribute('props-data', JSON.stringify(data));
};

export class ProductSliders extends HTMLElement {
  constructor(context) {
    super();
    if (context) this.mountProductCards(context);
  }
  async mountProductCards(context) {
    const app = context.querySelector('.js-product-slider');
    const jsonScript = context.querySelector('.js-product-slider-json');
    if (!app || !jsonScript) return;
    passJsonAsProp(app, jsonScript.innerHTML);
    await passJsonAsProp(app, jsonScript.innerHTML);
    mountVue('.js-product-slider', ProductSlider, context);
  }
}

export class ProductGrids extends HTMLElement {
  constructor(context) {
    super();
    if (context) this.mountProductCards(context);
  }
  mountProductCards(context) {
    //if the in page navigation module exists on a landing page or PLP, prevent auto scrolling to the top of the page on load
    if (!document.querySelector('.page-navigation')) window.scrollTo(0, 0);

    const app = context.querySelector('.js-product-grid');
    const jsonScript = context.querySelector('.js-product-grid-json');
    if (!app || !jsonScript) return;
    passJsonAsProp(app, jsonScript.innerHTML);
    mountVueWithPinia('.js-product-grid', ProductGrid, context);
  }
}

customElements.define('product-grid', ProductGrids);
customElements.define('product-slider', ProductSliders);
